<div class="page">
  <!-- Sidebar -->
  <aside class="sidebar">
    <div class="sidebar-header">
      <div class="logo">
        <div class="logo-icon">r</div>
        <span class="logo-text">rubii</span>
      </div>
    </div>

    <nav class="sidebar-nav">
      <a class="nav-link">
        <svg class="nav-icon" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 8L9 1L17 8M3 6.5V14.5C3 14.7761 3.22386 15 3.5 15H7V11C7 10.4477 7.44772 10 8 10H10C10.5523 10 11 10.4477 11 11V15H14.5C14.7761 15 15 14.7761 15 14.5V6.5" stroke="#4B5563" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Dashboard</span>
      </a>
      <a class="nav-link active">
        <svg class="nav-icon" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 8L3 1H15L17 8M1 8V14C1 14.5523 1.44772 15 2 15H16C16.5523 15 17 14.5523 17 14V8M1 8H7L8 10H10L11 8H17" stroke="#E70F96" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>AI Analysis</span>
      </a>
      <a class="nav-link">
        <svg class="nav-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 4L8 1L15 4M1 4L8 7M1 4V12L8 15M15 4L8 7M15 4V12L8 15M8 7V15" stroke="#4B5563" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Data Sources</span>
      </a>
      <a class="nav-link">
        <svg class="nav-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1H6V7H1V1ZM10 1H15V4H10V1ZM10 7H15V15H10V7ZM1 10H6V15H1V10Z" stroke="#4B5563" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Reports</span>
      </a>

      <div class="nav-section-label">SETTINGS</div>

      <a class="nav-link">
        <svg class="nav-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.5 1.5H2C1.72386 1.5 1.5 1.72386 1.5 2V6.5C1.5 6.77614 1.72386 7 2 7H6.5C6.77614 7 7 6.77614 7 6.5V2C7 1.72386 6.77614 1.5 6.5 1.5ZM6.5 9H2C1.72386 9 1.5 9.22386 1.5 9.5V14C1.5 14.2761 1.72386 14.5 2 14.5H6.5C6.77614 14.5 7 14.2761 7 14V9.5C7 9.22386 6.77614 9 6.5 9ZM14 1.5H9.5C9.22386 1.5 9 1.72386 9 2V6.5C9 6.77614 9.22386 7 9.5 7H14C14.2761 7 14.5 6.77614 14.5 6.5V2C14.5 1.72386 14.2761 1.5 14 1.5ZM14 9H9.5C9.22386 9 9 9.22386 9 9.5V14C9 14.2761 9.22386 14.5 9.5 14.5H14C14.2761 14.5 14.5 14.2761 14.5 14V9.5C14.5 9.22386 14.2761 9 14 9Z" stroke="#4B5563" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Configuration</span>
      </a>
      <a class="nav-link">
        <svg class="nav-icon" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 15V13.5C14 11.8431 12.6569 10.5 11 10.5H5C3.34315 10.5 2 11.8431 2 13.5V15M18 15V13.5C18 12.1193 17.0518 10.9508 15.7644 10.5885M12.7644 1.58848C14.0518 1.95076 15 3.11929 15 4.5C15 5.88071 14.0518 7.04924 12.7644 7.41152M8 7.5C6.34315 7.5 5 6.15685 5 4.5C5 2.84315 6.34315 1.5 8 1.5C9.65685 1.5 11 2.84315 11 4.5C11 6.15685 9.65685 7.5 8 7.5Z" stroke="#4B5563" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Team</span>
      </a>
    </nav>

    <div class="sidebar-footer">
      <div class="user-info">
        <div class="user-avatar">
          <img src="https://www.figma.com/api/mcp/asset/56ecc6f8-87e0-4b0b-ac9a-45fd8909dc63" alt="User avatar" />
        </div>
        <div class="user-details">
          <div class="user-name">Sarah Jenkins</div>
          <div class="user-email">sarah&#64;rubii.com</div>
        </div>
      </div>
    </div>
  </aside>

  <!-- Main Content -->
  <div class="main">
    <!-- Header -->
    <header class="header">
      <h1 class="header-title">New AI Analysis</h1>
      <div class="header-actions">
        <button class="icon-btn">
          <svg viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.5 14.5C5.82588 14.9783 6.37592 15.25 7 15.25C7.62408 15.25 8.17412 14.9783 8.5 14.5M1.28735 11.5H12.7127C13.2074 11.5 13.4853 10.9214 13.1799 10.5286L11.75 8.69108V5.25C11.75 2.62665 9.62335 0.5 7 0.5C4.37665 0.5 2.25 2.62665 2.25 5.25V8.69108L0.820149 10.5286C0.514744 10.9214 0.792604 11.5 1.28735 11.5Z" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="icon-btn">
          <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z" stroke="#6B7280" stroke-width="1.5"/>
            <path d="M8 11V8M8 5H8.01" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </header>

    <!-- Content Area -->
    <div class="content-area">
      <div class="content-container">

        <!-- Progress Stepper -->
        <div class="stepper">
          <div class="stepper-track"></div>
          <div class="stepper-progress"></div>

          <div class="step">
            <div class="step-circle completed">
              <svg viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 8.5L5 12.5L13 3.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="step-label">Upload Data</span>
          </div>

          <div class="step">
            <div class="step-circle completed">
              <svg viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 8.5L5 12.5L13 3.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="step-label">AI Analysis</span>
          </div>

          <div class="step">
            <div class="step-circle active">
              <span>3</span>
            </div>
            <span class="step-label active-label">Results</span>
          </div>
        </div>

        <!-- Main Card -->
        <div class="card">
          <!-- Card Header -->
          <div class="card-header">
            <div class="card-header-top">
              <div class="card-title-section">
                <h2 class="card-title">Analysis Complete</h2>
                <p class="card-subtitle">Review the AI's classification for your uploaded data source.</p>
              </div>
              <div class="file-badge">
                <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 1H3C2.44772 1 2 1.44772 2 2V14C2 14.5523 2.44772 15 3 15H13C13.5523 15 14 14.5523 14 14V6M9 1L14 6M9 1V5C9 5.55228 9.44772 6 10 6H14" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Q1_Campaign_Expor...</span>
              </div>
            </div>

            <!-- Recommendation Card -->
            <div class="recommendation-card">
              <div class="recommendation-blur"></div>
              <div class="recommendation-content">
                <div class="recommendation-left">
                  <div class="recommendation-badge">
                    <svg viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 1L11.5 6L17 7L13 11L14 16L9 13.5L4 16L5 11L1 7L6.5 6L9 1Z" fill="#FDE68A" stroke="#FDE68A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>AI RECOMMENDATION</span>
                  </div>
                  <h3 class="recommendation-title">DSP (Demand Side Platform)</h3>
                  <p class="recommendation-desc">
                    Based on the column headers and data patterns detected in your CSV file, our AI
                    strongly suggests classifying this source as a DSP.
                  </p>
                </div>
                <div class="confidence-box">
                  <div class="confidence-label">Confidence Score</div>
                  <div class="confidence-value">98%</div>
                  <div class="confidence-bar">
                    <div class="confidence-fill"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Card Body -->
          <div class="card-body">
            <!-- Reason Section -->
            <div class="section">
              <div class="section-header">
                <svg class="section-icon" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 1L11.5 4L15.5 2.5L14.5 6.5L17 9L14.5 11.5L15.5 15.5L11.5 14L9 17L6.5 14L2.5 15.5L3.5 11.5L1 9L3.5 6.5L2.5 2.5L6.5 4L9 1Z" fill="#F59E0B" stroke="#F59E0B" stroke-width="1.2"/>
                </svg>
                <h4>Reason for Recommendation</h4>
              </div>
              <div class="reason-list">
                <div class="reason-item">
                  <svg class="check-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="8" fill="#22C55E"/>
                    <path d="M5 8L7 10L11 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="reason-text">
                    <strong>Campaign Hierarchy Detected</strong>
                    <span>Found 'Campaign Advertiser ID', 'IO Group Name', and 'Placement ID' columns typical of DSP exports.</span>
                  </div>
                </div>
                <div class="reason-item">
                  <svg class="check-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="8" fill="#22C55E"/>
                    <path d="M5 8L7 10L11 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="reason-text">
                    <strong>Performance Metrics Present</strong>
                    <span>Contains 'Impressions', 'Clicks', 'Video View', and 'CTR' which align with buying platform outputs.</span>
                  </div>
                </div>
                <div class="reason-item">
                  <svg class="check-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="8" fill="#22C55E"/>
                    <path d="M5 8L7 10L11 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="reason-text">
                    <strong>Creative Data Structure</strong>
                    <span>Presence of 'Creative Key', 'Creative Name', and 'Creative Title Name' indicates ad serving/buying capabilities.</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Override Section -->
            <div class="section">
              <div class="section-header">
                <svg class="section-icon" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1Z" stroke="#6B7280" stroke-width="1.5"/>
                  <path d="M6 9L8 11L12 7" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <h4>Manual Override</h4>
              </div>
              <p class="override-desc">
                If the AI recommendation is incorrect, you can manually
                select the appropriate classification below.
              </p>
              <div class="radio-group">
                <label class="radio-option" [class.selected]="selectedClassification === 'dsp'">
                  <div class="radio-circle" [class.checked]="selectedClassification === 'dsp'">
                    <div class="radio-dot"></div>
                  </div>
                  <div class="radio-content">
                    <div class="radio-label">DSP (Demand Side Platform)</div>
                    <div class="radio-sublabel">Recommended</div>
                  </div>
                  <input type="radio" name="classification" value="dsp" [(ngModel)]="selectedClassification" hidden />
                </label>
                <label class="radio-option" [class.selected]="selectedClassification === 'adserver'">
                  <div class="radio-circle" [class.checked]="selectedClassification === 'adserver'">
                    <div class="radio-dot"></div>
                  </div>
                  <div class="radio-content">
                    <div class="radio-label">Ad Server</div>
                    <div class="radio-sublabel">Primary ad delivery and tracking</div>
                  </div>
                  <input type="radio" name="classification" value="adserver" [(ngModel)]="selectedClassification" hidden />
                </label>
                <label class="radio-option" [class.selected]="selectedClassification === 'verification'">
                  <div class="radio-circle" [class.checked]="selectedClassification === 'verification'">
                    <div class="radio-dot"></div>
                  </div>
                  <div class="radio-content">
                    <div class="radio-label">Verification Platform</div>
                    <div class="radio-sublabel">Brand safety, viewability, and fraud detection</div>
                  </div>
                  <input type="radio" name="classification" value="verification" [(ngModel)]="selectedClassification" hidden />
                </label>
              </div>
            </div>
          </div>

          <!-- Card Footer -->
          <div class="card-footer">
            <button class="btn-secondary">
              <svg viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 8H1M1 8L6 3M1 8L6 13" stroke="#374151" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Back
            </button>
            <button class="btn-primary">
              Next
              <svg viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 8H13M13 8L8 3M13 8L8 13" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
